import { useContext } from 'react'
import { Form } from 'react-bootstrap'
import {
  CaretUpFill,
  VolumeUp,
  VolumeDown,
  VolumeMute,
} from 'react-bootstrap-icons'
import { PlayerContext } from '../../pages/Home'

const VolumeControls = () => {
  const { volume, setVolume } = useContext(PlayerContext)

  return (
    <>
      <button className='btn border-0 p-2 m-1'>
        {volume <= 1 && volume > 0.5 && (
          <VolumeUp
            onClick={() => setVolume(0)}
            className='w-100 text-light-emphasis'
            size={18}
          />
        )}
        {volume <= 0.5 && volume > 0 && (
          <VolumeDown
            onClick={() => setVolume(0)}
            className='w-100 text-light-emphasis'
            size={18}
          />
        )}
        {volume <= 0 && (
          <VolumeMute
            onClick={() => setVolume(1)}
            className='w-100 text-light-emphasis'
            size={18}
          />
        )}
      </button>
      <Form.Range
        className='player-volume align-self-center'
        min={0}
        max={1}
        step='any'
        value={volume}
        onChange={(e) => setVolume(e.target.value)}
      />
      <button className='btn border-0 p-2 m-1'>
        <CaretUpFill className='w-100 text-light-emphasis' size={18} />
      </button>
    </>
  )
}
export default VolumeControls
